/* GreenIT BF/CM landing: product-type chips. Without JS the chips are plain jump links to each group's anchor.
   With JS a chip shows only its group ("All" shows every group). The group id in the URL hash is kept so a
   filtered view can be shared. No layout shift: groups are hidden with the hidden attribute, nothing is fetched. */
(function () {
  var root = document.querySelector('.gi-bfcm');
  var nav = root && root.querySelector('[data-gi-filter]');
  if (!nav) return;
  var chips = Array.prototype.slice.call(nav.querySelectorAll('a[data-gi-type]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-gi-group]'));
  var allHref = nav.querySelector('a[data-gi-type="all"]').getAttribute('href');

  function apply(type) {
    chips.forEach(function (c) {
      if (c.getAttribute('data-gi-type') === type) c.setAttribute('aria-current', 'true');
      else c.removeAttribute('aria-current');
    });
    groups.forEach(function (g) {
      g.hidden = !(type === 'all' || g.getAttribute('data-gi-group') === type);
    });
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function (e) {
      var type = c.getAttribute('data-gi-type');
      e.preventDefault();
      apply(type);
      if (window.history && history.replaceState) {
        history.replaceState(null, '', type === 'all' ? location.pathname + location.search : c.getAttribute('href'));
      }
      var first = groups.filter(function (g) { return !g.hidden; })[0];
      var target = type === 'all' ? document.querySelector(allHref) : first;
      var top = target && target.getBoundingClientRect().top;
      if (target && (top < 0 || top > window.innerHeight * 0.6)) target.scrollIntoView();
    });
  });

  var h = decodeURIComponent((location.hash || '').slice(1));
  var m = groups.filter(function (g) { return g.id === h; })[0];
  if (m) apply(m.getAttribute('data-gi-group'));
})();
